import ScheduleIntakeFormStepper from "@/components/forms/intake/scheduleIntake/ScheduleIntakeFormStepper"
import { ScheduleIntakeScoped } from "@/components/forms/intake/scheduleIntake/StepperDefinition"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useScheduleIntakeStore } from "@/stores/useScheduleIntakeStore"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"
import z from "zod"

export const Route = createFileRoute("/beheer/intakes/intake-plannen")({
  validateSearch: z.object({
    studentId: z.coerce.number().int().positive(),
  }),
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "intake"),
})

function RouteComponent() {
  const { selectedLocation } = useScheduleIntakeStore()
  const initialStep = selectedLocation ? "selectDate" : "selectLocation"

  return (
    <ScreenWrapper>
      <ScheduleIntakeScoped initialStep={initialStep}>
        <ScheduleIntakeFormStepper />
      </ScheduleIntakeScoped>
    </ScreenWrapper>
  )
}
